module.exports = __webpack_public_path__ + "img/login.5d4a67d7.jpg";